import React, { useEffect, useState } from "react";
import { AutoComplete, Select } from "antd";
import { toUpper } from "lodash";
import { getCompanyListApi } from "../../api/company.api";

const { Option } = AutoComplete;

const CompanyAutocomplete = ({
  onChange,
  disabled,
  value,
  singleValue = false,
  style = {},
  freeForm = false,
}) => {
  const [companyList, setCompanyList] = useState([]);
  const [currValue, setCurrValue] = useState(value || []);
  const [loading, setLoading] = useState(false);

  useEffect(() => setCurrValue(value), [value]);
  let mode = "";
  if (!singleValue) mode = freeForm ? "tags" : "multiple";
  return (
    <Select
      mode={mode}
      showSearch
      value={
        singleValue
          ? (currValue?.[0]?.id || currValue?.[0]?.name || currValue?.[0]?.toString() || undefined)
          : currValue?.map((el) => el?.id || el?.name || el?.toString())
      }
      filterOption={false}
      style={{ width: "100%", ...style }}
      disabled={disabled}
      loading={loading}
      allowClear
      onClear={() => {
        setCurrValue([]);
        if (typeof onChange === "function" && !disabled) {
          onChange([]);
        }
      }}
      onChange={(v, opt) => {
        let newVal;
        if (!v) {
          newVal = [];
        } else if (Array.isArray(v)) {
          newVal = v.map((val) => {
            const existing = (currValue || []).find(
              (el) => (el?.id || el?.name || el?.toString()) === val
            );
            if (existing) return existing;

            const option = Array.isArray(opt) ? opt.find((o) => o?.value === val) : null;
            if (option?.obj) return option.obj;

            return { id: val };
          });
        } else {
          let obj = (currValue || []).find(
            (el) => (el?.id || el?.name || el?.toString()) === v
          );
          if (!obj && opt?.obj) {
            obj = opt.obj;
          }
          newVal = obj ? [obj] : [{ id: v }];
        }

        setCurrValue(newVal);
        if (typeof onChange === "function" && !disabled) {
          onChange(newVal);
        }
      }}
      onSearch={async (val) => {
        if (val && val.length > 2) {
          setLoading(true);
          const res = await getCompanyListApi({
            params: {
              name: val,
            },
            abortChannel: "COMPANY_AUTOCOMPLETE",
          });
          if (!res.canceled) {
            setLoading(false);
            setCompanyList(
              (res.data || []).map((r) => ({
                label: r.name,
                value: r._id,
                obj: { id: r._id, name: r.name },
              }))
            );
          }
        }
      }}
      placeholder={disabled ? "—" : ""}
    >
      {companyList.map((el, key) => (
        <Option key={key} value={el.value} obj={el.obj}>
          {toUpper(el.label)}
        </Option>
      ))}
    </Select>
  );
};

export default CompanyAutocomplete;
